 <div class="col-md-12">
    <nb-card>
      <nb-card-body>
        <div class="flex-centered col-12">
          <h2 class="title">404 Page Not Found</h2>
          <small class="sub-title">The page you were looking for doesn't exist</small>
          
        </div>
      </nb-card-body>
    </nb-card>
  </div>
